import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, Form, FormFeedback } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import InputCustom from "../../components/Common/InputCustom";
import { addNewTypeProperty, updateTypeProperty as onUpdateTypeProperty } from "store/CatTypeProperties/actions";


const FormTypeProperty = props => {

    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(props.isEdit);
    const [typePropertyL, setTypePropertyL] = useState(props.typeProperty);

     const { typePropertySaved, typeProperties} = useSelector(state => ({
        typePropertySaved: state.TypePropertyReducer.typePropertySaved,
        typeProperties: state.TypePropertyReducer.typeProperties
    }));

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name: (typePropertyL && typePropertyL.name) || "",
            typePropertyParent: (typePropertyL && typePropertyL.type_property_parent) || "",
            active: (typePropertyL && typePropertyL.active) || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Elige el día para el horario"),
            //active: Yup.string().required("Elige la hora de término"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const updateTypeProperty = {
                    id: typePropertyL ? typePropertyL.id : null,
                    name: values["name"],
                    active: typePropertyL.active,
                    typePropertyParent: values["typePropertyParent"],
                };
                dispatch(onUpdateTypeProperty(updateTypeProperty));
                //validation.resetForm();
            } else {
                try {
                    const newTypeProperty = {
                        name: values["name"],
                        typePropertyParent: values["typePropertyParent"],
                    };
                    dispatch(addNewTypeProperty(newTypeProperty));
                } catch (error) {
                    console.log(error)
                }
                //validation.resetForm();
            }
        }
    });

    const handleCheckChange = (e) => {
        console.log(e.target.value)
        setTypePropertyL(prev => ({
            ...prev,
            active: e.target.value === "si" ? true : false
        }))
    }

    useEffect(()=>{
        if(typePropertySaved) {
            validation.resetForm();
        }
    },[typePropertySaved])


    return (
        <React.Fragment>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <Row>
                
                <Col className="col-12">
                        <InputCustom
                            lblInput="Nombre del tipo de propiedad"
                            inputName="name"
                            inputType="text"
                            inputPlaceholder="Ingrese el nombre del tipo de propiedad"
                            validation={validation}
                        />                        
                </Col>
                
                <Col className="col-12">                        
                        <div className="mb-3">
                            <Label className="form-label">Tipo de propiedad Padre</Label>

                            <select className={"form-control"} onChange={validation.handleChange}
                                onBlur={validation.handleBlur} disabled={isEdit}
                                value={validation.values.typePropertyParent || ""}
                                name={"typePropertyParent"}>
                                <option value={""}>Elige...</option>
                                {
                                    typeProperties?.map((item, k) => {
                                        return <option key={k} value={item?.id}>{item?.name}</option>
                                    })
                                }
                            </select>
                            
                        </div>
                    </Col>
                    {
                        isEdit && (
                            <div className="mb-3 ">
                                <Label className="form-label">Activo</Label>
                                <div className="form-check mb-2">
                                    <Input
                                        name="active"
                                        type="radio" onClick={(e)=>handleCheckChange(e)}
                                        className="form-check-input"
                                        id="areaActive1" checked={typePropertyL.active}
                                        value="si"
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="areaActive1"
                                    >
                                        Activo
                                    </label>
                                </div>
                                <div className="form-check">
                                    <Input
                                        name="active"
                                        type="radio" onClick={(e)=>handleCheckChange(e)}
                                        className="form-check-input"
                                        id="areaActive2" checked={!typePropertyL.active}
                                        value="no"
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="areaActive2"
                                    >
                                        Baja
                                    </label>
                                </div>
                            </div>
                        )
                    }

                </Row>
                <Row>
                    <Col>
                        <div className="text-end">
                            <button
                                type="submit"
                                className="btn btn-success save-schedule"
                            >
                                { isEdit ? "Actualizar" : "Guardar"}
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default FormTypeProperty